import React, { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { socket } from "../config/socket";

import style from "../assets/css/page/Dashboard.module.css";

import Match from "../components/Match";
import ProxMatchs from "../components/ProxMatchs";
import Records from "../components/Records";
import Sponsors from "../components/Sponsors";
import TableGral from "../components/TableGral";
import TopGoal from "../components/TopGoal";
import Loading from "../components/Loading";
import sponsor from "../assets/img/sponsorprinc.gif";

// import useLoginPublic from "../hooks/useLoginPublic";

import {
  GET_MATCHES,
  GET_TABLE,
  GET_PLAYERS,
  GET_TOURNAMENTS,
} from "../graphql/queries";
import LogoHeader from "../components/Header/LogoHeader";
import SponsorPrincipal from "../components/sponsor/SponsorPrincipal";
import classNames from "classnames";
// import { useLocalStorage } from "../hooks/useLocalStorage";

const modalStates = { sponsor: true };

function Dashboard() {
  const { data, loading } = useQuery(GET_MATCHES);
  const table = useQuery(GET_TABLE);
  const players = useQuery(GET_PLAYERS);
  const tournaments = useQuery(GET_TOURNAMENTS);
  const [activeModals, setActiveModals] = useState(modalStates);
  const [modalActive, setModalActive] = useState(true);
  // const [role] = useLocalStorage("role", null);
  // const { loadingPublic, login } = useLoginPublic();
  const [matchs, setMatchs] = useState([]);
  const role = window.localStorage.getItem("role");

  useEffect(() => {
    if (!loading && data) {
      let matchOrder = [...data.matchs];
      matchOrder.sort(
        (a, b) =>
          a.day - b.day ||
          new Date(a.date).getTime() - new Date(b.date).getTime() ||
          a?.hour?.split(":")[0] - b?.hour?.split(":")[0]
      );
      setMatchs(matchOrder);
    }
  }, [loading, data]);

  useEffect(() => {
    socket.on("updateMatch", (res) => {
      let arrayMatchs = [...matchs];
      const objIndex = arrayMatchs.findIndex((obj) => obj.id === res.match.id);
      let updateMatch = { ...res.match };

      arrayMatchs.splice(objIndex, 1, updateMatch);
      setMatchs(arrayMatchs);
    });
  }, [matchs]);

  useEffect(() => {
    socket.on("changeStatus", (res) => {
      let arrayMatchs = [...matchs];
      const objIndex = arrayMatchs.findIndex(
        (obj) => obj.id === res.statusChange.id
      );
      let updateMatch = { ...res.statusChange };

      arrayMatchs.splice(objIndex, 1, updateMatch);
      setMatchs(arrayMatchs);
    });
  }, [matchs]);

  useEffect(() => {
    socket.on("changeLive", (res) => {
      let arrayMatchs = [...matchs];
      const objIndex = arrayMatchs.findIndex(
        (obj) => obj.id === res.liveChange.id
      );
      let updateMatch = { ...res.liveChange };

      arrayMatchs.splice(objIndex, 1, updateMatch);
      setMatchs(arrayMatchs);
    });
  }, [matchs]);

  // if (loading || loadingPublic || table.loading || playersQuery.loading)
  if (loading || table.loading || players.loading || tournaments.loading)
    return <Loading />;

  const changeModalState = (modal) => async () => {
    setActiveModals({ ...activeModals, [modal]: !activeModals[modal] });
    setModalActive(!modalActive);
  };

  return (
    <div
      className={
        modalActive && role !== "Admin"
          ? classNames(style.container, style.noScroll)
          : style.container
      }
    >
      <div className={style.content}>
        <div className={style.matchs}>
          <div className={style.logo}>
            <LogoHeader />
          </div>
          <div className={style.matchsList}>
            <div className={style.matchsLive}>
              {matchs &&
                matchs.map((match) =>
                  match.live ? (
                    <ProxMatchs
                      key={match.id}
                      match={match}
                      tournament={tournaments.data.tournaments[0].name}
                    />
                  ) : null
                )}
              {/* <ProxMatchs /> */}
            </div>
            <div className={style.allMatchs}>
              <div className={style.contTitle}>
                <p className={style.title}>Lista de partidos</p>
              </div>
              <div className={style.listMatchs}>
                {matchs &&
                  matchs.map((match) =>
                    !match.live
                      ? match.StatusMatch !== "fin" &&
                        match.date && (
                          <Match
                            key={match.id}
                            match={match}
                            tournament={tournaments.data.tournaments[0].name}
                          />
                        )
                      : null
                  )}
              </div>
            </div>
          </div>
        </div>
        <div className={style.statistics}>
          <div className={style.contRecord}>
            <Records
              data={table?.data && table?.data}
              tournament={tournaments?.data?.tournaments[0]?.name}
            />
          </div>
          <div className={style.contTable}>
            <div className={style.contTitle}>
              <p className={style.title}>Tabla general</p>
            </div>
            <div className={style.table}>
              <TableGral data={table.data?.generalTables} />
            </div>
          </div>
        </div>
      </div>
      <div className={style.contInfo}>
        <div className={style.contTopGoal}>
          <TopGoal data={players?.data?.players && players?.data?.players} />
        </div>
        <div className={style.contSponsor}>
          <Sponsors />
          {/* <img className={style.sponsor} src={sponsor} alt="" /> */}
        </div>
      </div>
      {role !== "Admin" && (
        <SponsorPrincipal
          img={sponsor}
          show={activeModals.sponsor}
          close={changeModalState("sponsor")}
        />
      )}
    </div>
  );
}

export default Dashboard;
